import { useDialog } from '@react/chakra/core';
import { Box, Dialog, Portal } from '@react/chakra';

import type { JSX, ReactNode } from 'react';

interface IKofiModalProps {
  trigger: ReactNode;
}

export function KofiModal({ trigger }: IKofiModalProps): JSX.Element {
  const { isOpen, onOpenChange } = useDialog();

  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange} size='sm'>
      <Dialog.Trigger asChild>{trigger}</Dialog.Trigger>
      <Portal>
        <Dialog.Backdrop
          bg='blackAlpha.300'
          filter='blur(10px) hue-rotate(90deg)'
        />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Body>
              <Box h='570px' border={0} width='100%' asChild>
                <iframe
                  id='kofiframe'
                  title='zgid123'
                  src='https://ko-fi.com/zgid123/?hidefeed=true&widget=true&embed=true&preview=true'
                />
              </Box>
            </Dialog.Body>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
}
